import { WarningToast } from "../../ToastComponent/RectHotToast";
//new
export const enterKeyHandle = (
  e,
  // setFieldContent,
  inputContent,
  InputConfig,
  SelectedDate,
  name,
  ReferedFieldDate,
  value,
  formkey
) => {
  console.log({
    e,
    inputContent,
    InputConfig,
    SelectedDate,
    name,
    ReferedFieldDate,
  });
  if (e.key === "Tab") {
    const input = e.target.value.trim();
    let values, day, month, year, selectedDate;
    console.log(input, "input");
    // Handle single number input directly
    if (/^\d{1,2}$/.test(input)) {
      day = parseInt(input, 10);
      month = new Date().getMonth(); // Use current month
      year = new Date().getFullYear(); // Use current year
      values = [input]; // Single day input
    } else {
      // Split the input based on allowed separators
      if (input.includes("/")) {
        values = input.split("/");
      } else if (input.includes(".")) {
        values = input.split(".");
      } else if (input.includes("-")) {
        values = input.split("-");
      } else {
        WarningToast("Invalid date format.");
        return;
      }

      day = parseInt(values[0], 10);
      if (values.length === 1) {
        month = new Date().getMonth(); // Use current month if month is not provided
        year = new Date().getFullYear(); // Use current year if year is not provided
      } else {
        month = parseInt(values[1], 10) - 1; // Adjust month to 0-based index
        if (values.length === 2) {
          year = new Date().getFullYear(); // Use current year if year is not provided
        } else {
          year = parseInt(values[2], 10);
          year = year < 100 ? year + 2000 : year; // Adjust for 2-digit years
        }
      }
    }

    selectedDate = new Date(year, month, day);
    console.log(values, day, month, year, selectedDate, "gghh");
    // Validate the parsed date to ensure it matches the input values
    if (
      isNaN(selectedDate.getTime()) ||
      selectedDate.getDate() !== day ||
      selectedDate.getMonth() !== month ||
      selectedDate.getFullYear() !== year
    ) {
      WarningToast("Invalid date input.");
      return;
    }

    // Additional date range checks and setting the date
    if (InputConfig?.restrictDateRange) {
      const financialYear = sessionStorage.getItem("SelectedFinancialYear");
      const financialYearRange = financialYear ? JSON.parse(financialYear).yearRange : null;
      // console.log(financialYearRange);
      if (financialYearRange) {
        const startDate = new Date(financialYearRange?.split(" - ")[0].split("/").reverse().join("-"));
        const endDate = new Date(financialYearRange?.split(" - ")[1].split("/").reverse().join("-"));
        // console.log(startDate, endDate);
        const toDate = new Date(SelectedDate?.ToDate);
        const fromDate = new Date(SelectedDate?.FromDate);
        const toDayDate = new Date();
        let EwayBillDate;
        if (InputConfig?.Reference_field && InputConfig?.Reference_field !== "financialYear") {
          const [day, month, year] = ReferedFieldDate?.split("/")?.map(Number);
          const dstring = new Date(year, month - 1, day);
          EwayBillDate = dstring;
        }
        console.log();
        toDayDate?.setHours(0, 0, 0, 0);
        selectedDate?.setHours(0, 0, 0, 0);
        startDate?.setHours(0, 0, 0, 0);
        endDate?.setHours(0, 0, 0, 0);
        EwayBillDate?.setHours(0, 0, 0, 0);
        console.log(selectedDate, EwayBillDate, toDayDate);
        if (selectedDate < startDate || selectedDate > endDate) {
          WarningToast("Selected date is outside the financial year range.");
          return;
        } else if (name === "From" && selectedDate > toDate) {
          WarningToast("From date cannot be after To date.");
          return;
        } else if (name === "To" && selectedDate < fromDate) {
          WarningToast("To date cannot be before From date.");
          return;
        } else if (name === "Eway_Bill_Expiry_Date" && selectedDate < EwayBillDate) {
          WarningToast("Expiry Date cannot be before Eway Bill date.");
          return;
        } else if (name === "Date" && formkey === "Live_Loads" && selectedDate < toDayDate) {
          WarningToast("Load Date cannot be before Today's date.");
          return;
        }
      }
    }
    const formattedDate = selectedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    console.log(formattedDate, "formattedDate");
    // setFieldContent(formattedDate);
    inputContent(formattedDate);
  }
};

//old
// export const enterKeyHandle = (
//   e,
//   setFieldContent,
//   inputContent,
//   InputConfig,
//   SelectedDate,
//   name,
//   ReferedFieldDate,
//   value
// ) => {
//   if (e.key === "Tab") {
//     const input = e.target.value.trim();
//     let values, day, month, year, selectedDate;

//     // Handle single number input directly
//     if (/^\d{1,2}$/.test(input)) {
//       day = parseInt(input, 10);
//       month = new Date().getMonth(); // Use current month
//       year = new Date().getFullYear(); // Use current year
//       values = [input]; // Single day input
//     } else {
//       // Split the input based on allowed separators
//       if (input.includes("/")) {
//         values = input.split("/");
//       } else if (input.includes(".")) {
//         values = input.split(".");
//       } else if (input.includes("-")) {
//         values = input.split("-");
//       } else {
//         WarningToast("Invalid date format.");
//         return;
//       }

//       day = parseInt(values[0], 10);
//       if (values.length === 1) {
//         month = new Date().getMonth(); // Use current month if month is not provided
//         year = new Date().getFullYear(); // Use current year if year is not provided
//       } else {
//         month = parseInt(values[1], 10) - 1; // Adjust month to 0-based index
//         if (values.length === 2) {
//           year = new Date().getFullYear(); // Use current year if year is not provided
//         } else {
//           year = parseInt(values[2], 10);
//           year = year < 100 ? year + 2000 : year; // Adjust for 2-digit years
//         }
//       }
//     }

//     selectedDate = new Date(year, month, day);

//     // Validate the parsed date to ensure it matches the input values
//     if (
//       isNaN(selectedDate.getTime()) ||
//       selectedDate.getDate() !== day ||
//       selectedDate.getMonth() !== month ||
//       selectedDate.getFullYear() !== year
//     ) {
//       WarningToast("Invalid date input.");
//       return;
//     }

//     // Additional date range checks and setting the date
//     if (InputConfig?.restrictDateRange) {
//       const financialYear = sessionStorage.getItem("SelectedFinancialYear");
//       const financialYearRange = financialYear ? JSON.parse(financialYear).yearRange : null;
//       if (financialYearRange) {
//         const startDate = new Date(financialYearRange?.split(" - ")[0].split("/").reverse().join("-"));
//         const endDate = new Date(financialYearRange?.split(" - ")[1].split("/").reverse().join("-"));
//         const toDate = new Date(SelectedDate?.ToDate);
//         const fromDate = new Date(SelectedDate?.FromDate);
//         const [day, month, year] = ReferedFieldDate.split("/").map(Number);
//         const dstring = new Date(year, month - 1, day);
//         let EwayBillDate = dstring;

//         selectedDate?.setHours(0, 0, 0, 0);
//         startDate?.setHours(0, 0, 0, 0);
//         endDate?.setHours(0, 0, 0, 0);
//         EwayBillDate?.setHours(0, 0, 0, 0);
//         if (selectedDate < startDate || selectedDate >= endDate) {
//           WarningToast("Selected date is outside the financial year range.");
//           return;
//         } else if (name === "From" && selectedDate > toDate) {
//           WarningToast("From date cannot be after To date.");
//           return;
//         } else if (name === "To" && selectedDate < fromDate) {
//           WarningToast("To date cannot be before From date.");
//           return;
//         } else if (name === "Eway_Bill_Expiry_Date" && selectedDate < EwayBillDate) {
//           WarningToast("Expiry Date cannot be before Eway Bill date.");
//           return;
//         }
//       }
//     }

//     const formattedDate = selectedDate.toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });

//     setFieldContent(formattedDate);
//     inputContent(formattedDate);
//   }
// };

// export const enterKeyHandle = (e, setFieldContent, inputContent, InputConfig, SelectedDate, name) => {
//   if (e.key === "Tab") {
//     //e.preventDefault();
//     // Parse the date input
//     const input = e.target.value;
//     let values, day, month, year, selectedDate;
//     if (input.includes("/")) {
//       values = input.split("/");
//     } else if (input.includes(".")) {
//       values = input.split(".");
//     }
//     if (!values) return; // Exit if the input format is not recognized
//     day = parseInt(values[0], 10);
//     month = parseInt(values[1], 10) - 1; // Adjust month to 0-based index
//     if (values.length === 2) {
//       year = new Date().getFullYear(); // Use current year if year is not provided
//     } else if (values.length === 3) {
//       year = parseInt(values[2], 10);
//       year = year < 100 ? year + 2000 : year; // Adjust for 2-digit years
//     }
//     selectedDate = new Date(year, month, day);
//     if (InputConfig?.restrictDateRange) {
//       // Check against the financial year range only if restrictDateRange is true
//       const financialYear = sessionStorage.getItem("SelectedFinancialYear");
//       const financialYearRange = financialYear ? JSON.parse(financialYear).yearRange : null;
//       if (financialYearRange) {
//         const startDate = new Date(financialYearRange?.split(" - ")[0].split("/").reverse().join("-"));
//         const endDate = new Date(financialYearRange?.split(" - ")[1].split("/").reverse().join("-"));
//         const toDate = new Date(SelectedDate?.ToDate);
//         const fromDate = new Date(SelectedDate?.FromDate);

//         selectedDate?.setHours(0, 0, 0, 0);
//         startDate?.setHours(0, 0, 0, 0);
//         endDate?.setHours(0, 0, 0, 0);

//         if (selectedDate < startDate || selectedDate >= endDate) {
//           WarningToast("Selected date is outside the financial year range.");
//           return;
//         } else if (name == "From" && selectedDate > toDate) {
//           WarningToast("From date cannot be after To date.");
//           return;
//         } else if (name == "To" && selectedDate < fromDate) {
//           WarningToast("To date cannot be before From date.");
//           return;
//         }
//       }

//       selectedDate = new Date(year, month, day);
//     }

//     // Format and set the date if it's within the allowed range or if range restriction isn't applied
//     const formattedDate = selectedDate.toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//     });

//     setFieldContent(formattedDate);
//     inputContent(formattedDate);
//   }
// };
